import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function MotorSVG({ value, config = {}, width = 50, height = 40 }) {
    const running = parseFloat(value) >= (parseFloat(config.threshold ?? 0.5));
    const color = running ? '#22C55E' : '#64748B';
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Motor body */}
            <rect x={4} y={8} width={width - 16} height={height - 16} rx={4} fill="#1E293B" stroke={color} strokeWidth={2} />
            {/* "M" label */}
            <text x={(width - 12) / 2 + 4} y={height / 2 + 4} textAnchor="middle" fill={color} fontSize={12} fontWeight="bold">M</text>
            {/* Shaft */}
            <rect x={width - 12} y={height / 2 - 3} width={10} height={6} rx={2} fill={color} />
        </svg>
    );
}

export default function MotorNode(props) {
    const { data } = props;
    return (
        <BaseScadaNode {...props}>
            <MotorSVG value={data?.liveValue} config={data?.config} width={data?.width || 50} height={data?.height || 40} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
